import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { AccVentureStatusType } from '@interfaces';
import { AcceleratorAreaService } from '../../../accelerator-area.service';


@Component({
	selector: 'acc-delivery-graduation-tab-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-delivery-graduation-tab.part.html',
})
export class AccDeliveryGraduationTabPart {

	private readonly accAreaService = inject(AcceleratorAreaService);

	public ventureStatusCount = computed(() => {
		const data = this.accAreaService.data();
		if (!data) return undefined;

		const statusCounts = data.ventures.reduce((map, venture) => {
			map[venture.status] = (map[venture.status] || 0) + 1;
			return map;
		}, { 'Participating': 0, 'Dropped Out': 0, 'Never Started': 0, 'Graduated': 0 } as Record<AccVentureStatusType, number>);

		return {
			...statusCounts,
			totalVentures: data.ventures.length,
		}
	});
}
